import userService from '@/config/axiosUserService.js';
import partnerSwal from './partnerSwal';

export default {
  async getUserDetails(userCodes, fields = '') {
    let result = {};
    await userService
      .get(`v1/users?user_code=${userCodes}&fields=${fields}&limit=500`)
      .then((response) => {
        result = response;
      })
      .catch((error) => {
        partnerSwal.errorToast.fire({
          title: 'User Service Error!',
          text: error.response.data?.message
        });
        throw error;
      });
    return result;
  },
  mapUsersIntoObject(data) {
    let userDetails = {};
    if (data && Array.isArray(data)) {
      data.forEach((ele) => {
        userDetails[ele.user_code] = ele;
      });
    }
    return userDetails;
  }
};
